import { useState } from 'react';
import { Link } from "react-router-dom";
import { useAuth } from '@/contexts/UnifiedAuthContext';
import { useToast } from '@/hooks/use-toast';
import MainLayout from "@/components/layout/MainLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { resetPassword, loading } = useAuth();
  const { toast } = useToast();
  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      toast({
        title: t('common.error'),
        description: t('auth.forgot_password.error_no_email'),
        variant: "destructive",
      });
      return;
    }

    const { error } = await resetPassword(email);

    if (error) {
      toast({
        title: t('common.error'),
        description: error.message, // Уже переведено в AuthContext
        variant: "destructive",
      });
    } else {
      setIsSubmitted(true);
      toast({
        title: t('common.success'),
        description: t('auth.forgot_password.success_toast'),
      });
    }
  };

  return (
    <MainLayout>
      <div className="container-page flex items-center justify-center py-8 md:py-16">
        <div className="w-full max-w-md bg-card p-6 md:p-8 rounded-lg border shadow-sm">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold">{t('auth.forgot_password.title')}</h1>
            <p className="text-muted-foreground mt-1">
              {t('auth.forgot_password.subtitle')}
            </p>
          </div>

          {isSubmitted ? (
            <div className="text-center">
              <p className="mb-4">{t('auth.forgot_password.success_title')}</p>
              <p className="mb-6">{t('auth.forgot_password.success_desc')}</p>
              <Link to="/login">
                <Button variant="outline" className="mt-2">
                  {t('auth.forgot_password.back_to_login')}
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">{t('auth.common.email')}</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('auth.common.email_placeholder')}
                  required
                />
              </div>

              <Button
                type="submit"
                className="w-full"
                disabled={loading}
              >
                {loading ? t('auth.forgot_password.sending_btn') : t('auth.forgot_password.send_btn')}
              </Button>

              <div className="text-center text-sm">
                <span className="text-muted-foreground">{t('auth.forgot_password.remembered_password')}</span>{" "}
                <Link to="/login" className="text-brand-600 font-medium hover:underline">
                  {t('auth.common.login_link')}
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ForgotPassword;

